import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../web/components-v2/Theme/theme';

export const styleSheet = StyleSheet.create({
	container: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		padding: `${THEME.spacing.xxl}px ${THEME.spacing.sm + 2}px 0 ${THEME.spacing.sm + 2}px`, // Increased to 40px top padding for more spacing
		textAlign: 'center',
		minHeight: 300,
	},

	iconContainer: {
		marginBottom: THEME.spacing.lg + THEME.spacing.sm - 2,
	},

	icon: {
		width: 100,
		height: 100,
		'@media (max-width: 480px)': {
			width: 80,
			height: 80,
		},
	},

	iconSuccess: {
		color: THEME.colors.success.main,
	},

	iconError: {
		color: THEME.colors.danger.main,
	},

	iconWarning: {
		color: THEME.colors.warning.main,
	},

	title: {
		fontSize: THEME.typography.fontSizes.xxl,
		fontWeight: THEME.typography.fontWeights.bold,
		margin: `0 0 ${THEME.spacing.lg - 4}px 0`,
		lineHeight: '1.2',
		'@media (max-width: 480px)': {
			fontSize: 28,
		},
	},

	titleSuccess: {
		color: THEME.colors.success.main,
	},

	titleError: {
		color: THEME.colors.danger.main,
	},

	titleWarning: {
		color: THEME.colors.warning.main,
	},

	message: {
		fontSize: 20,
		color: THEME.colors.text.main,
		margin: `0 0 ${THEME.spacing.md - 1}px 0`,
		lineHeight: '1.4',
		maxWidth: 400,
		'@media (max-width: 480px)': {
			fontSize: THEME.typography.fontSizes.lg,
		},
	},

	subtitle: {
		fontSize: THEME.typography.fontSizes.xl,
		color: THEME.colors.text.main,
		margin: `${THEME.spacing.sm + 2}px 0 0 0`,
		fontWeight: THEME.typography.fontWeights.bold,
		'@media (max-width: 480px)': {
			fontSize: 20,
		},
	},

	guestCount: {
		fontSize: THEME.typography.fontSizes.md,
		color: THEME.colors.text.light,
		margin: `${THEME.spacing.sm}px 0 0 0`,
		fontWeight: THEME.typography.fontWeights.standard,
		'@media (max-width: 480px)': {
			fontSize: THEME.typography.fontSizes.sm,
		},
	},
});
